import Feature from "./feature";

export default Feature;
